import { ReactNode } from "react"
import styled from "styled-components"

interface Props {
  children: ReactNode
}

const AppSimulator = ({ children }: Props) => {
  return (
    <Device>
      <DeviceFrame>
        <DeviceScreen>
          <DeviceContent>{children}</DeviceContent>
        </DeviceScreen>
      </DeviceFrame>

      <DeviceHeader />
      <DeviceSensors />
      <DeviceButtons />
      <DevicePower />
    </Device>
  )
}

const baseDeviceHeightInPx = 868
const baseDeviceHeightInVh = 70

const convertPxToVh = (size: number): string => {
  switch (size) {
    case baseDeviceHeightInPx:
      return `${baseDeviceHeightInVh}`
    default:
      return ((size * baseDeviceHeightInVh) / baseDeviceHeightInPx).toFixed(2)
  }
}

const Device = styled.div`
  height: ${convertPxToVh(828)}vh;
  position: relative;
  width: ${convertPxToVh(428)}vh;
`

const DeviceFrame = styled.div`
  background-color: #222;
  border-radius: ${convertPxToVh(68)}vh;
  box-shadow: inset 0 0 ${convertPxToVh(2)}vh ${convertPxToVh(2)}vh #c8cacb,
    inset 0 0 0 ${convertPxToVh(7)}vh #e2e3e4;
  height: ${convertPxToVh(868)}vh;
  padding: ${convertPxToVh(19)}vh;
  width: ${convertPxToVh(428)}vh;
`

const DeviceScreen = styled.div`
  background-color: white;
  border-radius: ${convertPxToVh(49)}vh;
  height: 100%;
  overflow: hidden;
  width: 100%;
`

const DeviceContent = styled.div`
  height: 100%;
  overflow: auto;
`

const DeviceHeader = styled.div`
  background: #222;
  border-bottom-left-radius: ${convertPxToVh(20)}vh;
  border-bottom-right-radius: ${convertPxToVh(20)}vh;
  height: ${convertPxToVh(30)}vh;
  left: 50%;
  margin-left: -${convertPxToVh(80)}vh;
  position: absolute;
  top: ${convertPxToVh(18)}vh;
  width: ${convertPxToVh(160)}vh;

  &:after,
  &:before {
    content: "";
    height: ${convertPxToVh(10)}vh;
    position: absolute;
    top: 0;
    width: ${convertPxToVh(10)}vh;
  }

  &:after {
    background: radial-gradient(
      circle at bottom left,
      transparent 0,
      transparent 75%,
      #222 75%,
      #222 100%
    );
    left: -${convertPxToVh(10)}vh;
  }

  &:before {
    background: radial-gradient(
      circle at bottom right,
      transparent 0,
      transparent 75%,
      #222 75%,
      #222 100%
    );
    right: -${convertPxToVh(10)}vh;
  }
`

const DeviceSensors = styled.div`
  &:after,
  &:before {
    content: "";
    position: absolute;
  }

  &:after {
    background: #333;
    border-radius: ${convertPxToVh(3)}vh;
    height: ${convertPxToVh(6)}vh;
    left: 50%;
    margin-left: -${convertPxToVh(25)}vh;
    top: ${convertPxToVh(28)}vh;
    width: ${convertPxToVh(50)}vh;
  }

  &:before {
    background: radial-gradient(
        farthest-corner at 20% 20%,
        #6074bf 0,
        transparent 40%
      ),
      radial-gradient(
        farthest-corner at 80% 80%,
        #513785 0,
        #24555e 20%,
        transparent 50%
      );
    border-radius: 50%;
    box-shadow: 0 0 ${convertPxToVh(1)}vh ${convertPxToVh(1)}vh
      rgb(255 255 255 / 5%);
    height: ${convertPxToVh(10)}vh;
    left: 50%;
    margin-left: ${convertPxToVh(42)}vh;
    top: ${convertPxToVh(26)}vh;
    width: ${convertPxToVh(10)}vh;
  }
`

const DeviceButtons = styled.div`
  background: #c8cacb;
  height: ${convertPxToVh(32)}vh;
  left: -${convertPxToVh(3)}vh;
  position: absolute;
  top: ${convertPxToVh(115)}vh;
  width: ${convertPxToVh(3)}vh;

  &:after,
  &:before {
    background: #c8cacb;
    content: "";
    height: ${convertPxToVh(62)}vh;
    left: 0;
    position: absolute;
    width: ${convertPxToVh(3)}vh;
  }

  &:after {
    top: ${convertPxToVh(60)}vh;
  }

  &:before {
    top: ${convertPxToVh(140)}vh;
  }
`

const DevicePower = styled.div`
  background: #c8cacb;
  height: ${convertPxToVh(100)}vh;
  position: absolute;
  right: -${convertPxToVh(3)}vh;
  top: ${convertPxToVh(200)}vh;
  width: ${convertPxToVh(3)}vh;
`

export default AppSimulator
